import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Start Date", value: "START_DATE" },
  { label: "Booking Number", value: "BOOKING_NUMBER" },
  { label: "Buyer Company Name", value: "BUYER_COMPANY_NAME" },
  { label: "Location Name", value: "LOCATION_NAME" },
] as const satisfies Array<{label: string, value: string}>;

export type SupplierBookingCheckInSortByType = typeof sortByFields[number]['value'];

export interface SupplierBookingCheckInSortParams extends SortParams {
  sortBy?: SupplierBookingCheckInSortByType;
  sortDir?: SortDirType
}